import React from 'react';
import { GenericSettings } from './components/GenericSettings';

export type AccountSettingsForm =
  | 'firstname'
  | 'lastname'
  | 'job-position'
  | 'signature-job-position'
  | 'password'
  | 'new-password'
  | 'repeat-password';

interface Setting {
  title: string;
  fields: AccountSettingsForm[];
}

const settings: Setting[] = [
  {
    title: 'User settings',
    fields: ['firstname', 'lastname', 'job-position', 'signature-job-position'], //, 'language'
  },
  {
    title: 'Password settings',
    fields: ['password', 'new-password', 'repeat-password'],
  },
];

const AccountSettings = () => {
  return (
    <>
      {settings.map(({ title, fields }: Setting) => (
        <GenericSettings key={title} title={title} fields={fields} />
      ))}
    </>
  );
};

export default AccountSettings;
